import React from 'react'
import { formatMessage } from '@/utils/common'

const Page404 = () => {
  return (
    <div
      className="content-container"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
    >
      <div style={{ fontSize: '22px', textAlign: 'center' }}>
        <p style={{ marginBottom: '10px', fontSize: '25px', color: 'red' }}>
          {formatMessage('languageObj.commonLocale.errorAuth')}
        </p>
        <p>{formatMessage('languageObj.commonLocale.error404')}</p>
      </div>
    </div>
  )
}

export default Page404
